import ArticleFullThumbnail from "./ArticleFullThumbnail";

export default ArticleFullThumbnail;